import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { Avatar } from '@/components/atoms/Avatar/Avatar/Avatar';
import AvatarGroup from '@/components/atoms/Avatar/AvatarGroup/AvatarGroup';
import { RowActionIndicator } from '@/components/atoms/RowActionIndicator/RowActionIndicator';
import useUser from '@/hooks/useUser';
import { selectOnlineViewersByBrainId } from '@/redux/presence/selectors';
import { AIAgent } from '@/shared/types/brain';
import { RootState } from '@/shared/types/state';

interface NameCellProps {
  agent: AIAgent;
}

export function NameCell({ agent }: NameCellProps) {
  const { user } = useUser();
  const { viewers } = useSelector((state: RootState) =>
    selectOnlineViewersByBrainId(state, agent.brain_id)
  );

  const viewersWithoutMe = useMemo(
    () => viewers.filter(({ user_id }) => user_id !== user?.user_id),
    [user?.user_id, viewers]
  );

  return (
    <div className="flex items-center gap-3">
      <span className="min-w-0 truncate font-medium">{agent.name}</span>
      {viewersWithoutMe.length > 0 && (
        <AvatarGroup>
          {viewersWithoutMe.map((viewer) => (
            <Avatar key={viewer.user_id} userId={viewer.user_id} size="small" hideStatus />
          ))}
        </AvatarGroup>
      )}
      <RowActionIndicator action="view" />
    </div>
  );
}
